/* eslint-disable arrow-body-style */
import GameIds from 'a/hub/data/GameIds';

const constants = {
  GAME_ID: GameIds.SHOW_OFF,
  CURRICULUM_VERSION: '0.0.2',
  SCREEN_STATES: {
    game: 'game',
    progress: 'progress',
    onboarding: 'onboarding',
    loading: 'loading',
  },
  PERCENTAGE_MASTER_CRITERIA: 80,
  WHITE: '#FFFFFF',
  LIGHT_PURPLE: '#ede8f2',
  DARK_PURPLE: '#77578f',
  LIGHT_GRAY: '#f9f9f9',
  CONTAINER_COLOR: '#BBBBCE',
  TRANSPARENT: 'rgba(0, 0, 0, 0)',
  DONE_BUTTON_ACTIVE: '#008575',
  DONE_BUTTON_DISABLED: 'rgba(45, 181, 161, 0.3)',
  RGBA_WHITE: 'rgba(255, 255, 255, 1)',
  INCORRECT_BORDER_COLOR: 'rgba(243, 115, 33, 1)',
  CORRECT_BORDER_COLOR: 'rgba(45, 181, 160, 1)',
  SHADOW_CARD_BACKGROUND: '#D9FFFA',

  CARDFLIP_DURATION: 800,
  AUTOSCROLL_DURATION: 1000,
  DURATION_AUTOSCROLL_WAITS_ON_PICTURE: 2000,
  CARD_SNAP_TO_HOME_DURATION: 400,
  CARD_SNAP_ONBOARDING_DURATION: 2000,

  BORDER_HIGHLIGHT_THICKNESS: 10,
  BORDER_HIGHLIGHT_RAMP_UP_DURATION: 200,
  BORDER_HIHGLIGHT_STAY_AT_MAX_DURATION: 1000,
  BORDER_HIGHLIGHT_RAMP_DOWN_DURATION: 500,

  CARD_SIZE: 280,

  BORDER_HIGHLIGHT_TOTAL_DURATION: () => {
    return (
      constants.BORDER_HIGHLIGHT_RAMP_UP_DURATION +
      constants.BORDER_HIHGLIGHT_STAY_AT_MAX_DURATION +
      constants.BORDER_HIGHLIGHT_RAMP_DOWN_DURATION
    );
  },

  REDUX_ACTIONS: {
    BEGIN_LEVEL: 'BEGIN_LEVEL',
    RESET_CARDS_TO_INITIAL_STATE: 'RESET_CARDS_TO_INITIAL_STATE',
    RESET_POSITION_MARKERS_TO_INITIAL_STATE: 'RESET_POSITION_MARKERS_TO_INITIAL_STATE',
    TRIGGER_CARD_ACTION: 'TRIGGER_CARD_ACTION',
    UPDATE_CARD: 'UPDATE_CARD',
    UPDATE_CONTENT: 'UPDATE_CONTENT',
    UPDATE_SELECTED: 'UPDATE_SELECTED',
    UPDATE_MARKER: 'UPDATE_MARKER',
    UPDATE_MARKER_VISIBILITY: 'UPDATE_MARKER_VISIBILITY',
    UPDATE_CANDRAG: 'UPDATE_CANDRAG',
    UPDATE_CANSNAP: 'UPDATE_CANSNAP',
    UPDATE_DONEBUTTONENABLED: 'UPDATE_DONEBUTTONENABLED',
    UPDATE_SCREEN_STATE: 'UPDATE_SCREEN_STATE',
    UPDATE_LIGHTBULBSDISABLED: 'UPDATE_LIGHTBULBSDISABLED',
  },

  ONBOARDING_BY_COURSES: {
    K: 'K',
    PRIMERO: 'Primero',
    SEGUNDO: 'Segundo',
  },

  // validation expresion for string that contains ]] means it contains reveal words.
  REGEX_REVEAL_WORDS: /(\]]*){2,}/,

};

export default constants;
